import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CircleCheckboxProps } from "@/types";
export function CircleCheckbox(t0) {
  const $ = _c(8);
  const {
    checked,
    onCheckedChange,
    className
  } = t0;
  const t1 = checked ? "border-primary bg-primary text-primary-foreground" : "border-input bg-transparent hover:border-muted-foreground/50";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("h-[18px] w-[18px] rounded-full border-[1.5px] flex items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current transition-transform duration-200 ease-in-out scale-100 origin-center"><div className="h-[8px] w-[8px] rounded-full bg-white animate-in zoom-in-50 duration-200" /></CheckboxPrimitive.Indicator>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== checked || $[5] !== onCheckedChange || $[6] !== t2) {
    t4 = <CheckboxPrimitive.Root checked={checked} onCheckedChange={onCheckedChange} className={t2}>{t3}</CheckboxPrimitive.Root>;
    $[4] = checked;
    $[5] = onCheckedChange;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}